import {DateTime} from 'luxon';

import {BusinessHour} from '../../../../../libs/shared/core/src/models/api/businessHoursModel';

/*
  Defaults.
*/

export const defaultBusinessHours: BusinessHour = {
  opens: '09:00',
  closes: '17:00',
};

/*
 * Helpers.
 */

export function computeHourFromBusinessHoursTime(time: string): number {
  return Number(DateTime.fromISO(time).toFormat('HH'));
}
